import React, { useState } from 'react'
import LogoTransfix from 'transfix-ui/components/LogoTransfix'
import { makeStyles } from 'transfix-ui/core/styles'
import { Demos } from './components/Demos'
import { Login } from './components/Login'
import { ReactComponent as BackgroundLeftSvg } from './components/background-left.svg'
import { ReactComponent as BackgroundRightSvg } from './components/background-right.svg'

export const appName = 'product-demos'

const useDemosStyles = makeStyles(() => ({
  mainContainer: {
    maxWidth: '100%',
  },
  leftBackground: {
    top: '235px',
    opacity: '30%',
    position: 'absolute',
    right: '80vw',
  },
  rightBackground: {
    position: 'absolute',
    opacity: '30%',
    top: '0',
    right: '0',
    maxWidth: '30vw',
    overflow: 'hidden',
  },
  bottomLogoContainer: {
    display: 'flex',
    justifyContent: 'center',
    paddingBottom: '100px',
  },
}))

export function App() {
  const classes = useDemosStyles()
  const [isAuthenticated, setIsAuthenticated] = useState(false)

  const handleLogin = (password: string) => {
    if (password === 'tfdq124') {
      setIsAuthenticated(true)
      return true
    }
    return false
  }

  if (!isAuthenticated) {
    return <Login onLogin={handleLogin} />
  }

  return (
    <div className={classes.mainContainer}>
      <div className={classes.leftBackground}>
        <BackgroundLeftSvg />
      </div>
      <div className={classes.rightBackground}>
        <BackgroundRightSvg />
      </div>
      <Demos />
      <div className={classes.bottomLogoContainer}>
        <LogoTransfix color='white' />
      </div>
    </div>
  )
}
